import axios from 'axios'

async function get_tests_all(email,setTestArray,add_tests,dispatch,token,setLoading){

try{

  const data = {
    email:email
  }

  setLoading(true)

  const getTest = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-tests-all/`,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

  if (getTest?.status == 200 && getTest?.data.success == true) {

  setTestArray([...getTest?.data.tests,...getTest?.data.assessments])
  dispatch(add_tests([...getTest?.data.tests,...getTest?.data.assessments]))
  
  }
  setLoading(false)

}catch(err){
  console.log(err)
}
}

export default get_tests_all